"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    redirectToLogoutAsync: ()=>external_jwt_polyfill_js_namespaceObject.redirectToLogoutAsync,
    bytecloudJwtService: ()=>external_jwt_service_js_namespaceObject.bytecloudJwtService,
    bytecloudAsyncJwtService: ()=>external_async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService,
    logoutAsync: ()=>external_jwt_polyfill_js_namespaceObject.logoutAsync,
    redirectToSSO: ()=>external_jwt_polyfill_js_namespaceObject.redirectToSSO,
    redirectToLogout: ()=>external_jwt_sync_polyfill_js_namespaceObject.redirectToLogout,
    redirectToLogin: ()=>external_jwt_polyfill_js_namespaceObject.redirectToLogin,
    jwtUserInfo: ()=>external_jwt_util_js_namespaceObject.jwtUserInfo,
    logout: ()=>external_jwt_sync_polyfill_js_namespaceObject.logout,
    getJwt: ()=>external_jwt_polyfill_js_namespaceObject.getJwt,
    getJwtUserInfo: ()=>external_jwt_util_js_namespaceObject.getJwtUserInfo,
    fetchJwt: ()=>external_jwt_polyfill_js_namespaceObject.fetchJwt,
    parseJwt: ()=>external_jwt_util_js_namespaceObject.parseJwt
});
const external_jwt_service_js_namespaceObject = require("./jwt.service.js");
const external_async_jwt_service_js_namespaceObject = require("./async-jwt.service.js");
const external_jwt_polyfill_js_namespaceObject = require("./jwt.polyfill.js");
const external_jwt_sync_polyfill_js_namespaceObject = require("./jwt-sync.polyfill.js");
const external_jwt_util_js_namespaceObject = require("./jwt.util.js");
exports.bytecloudAsyncJwtService = __webpack_exports__.bytecloudAsyncJwtService;
exports.bytecloudJwtService = __webpack_exports__.bytecloudJwtService;
exports.fetchJwt = __webpack_exports__.fetchJwt;
exports.getJwt = __webpack_exports__.getJwt;
exports.getJwtUserInfo = __webpack_exports__.getJwtUserInfo;
exports.jwtUserInfo = __webpack_exports__.jwtUserInfo;
exports.logout = __webpack_exports__.logout;
exports.logoutAsync = __webpack_exports__.logoutAsync;
exports.parseJwt = __webpack_exports__.parseJwt;
exports.redirectToLogin = __webpack_exports__.redirectToLogin;
exports.redirectToLogout = __webpack_exports__.redirectToLogout;
exports.redirectToLogoutAsync = __webpack_exports__.redirectToLogoutAsync;
exports.redirectToSSO = __webpack_exports__.redirectToSSO;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "bytecloudAsyncJwtService",
    "bytecloudJwtService",
    "fetchJwt",
    "getJwt",
    "getJwtUserInfo",
    "jwtUserInfo",
    "logout",
    "logoutAsync",
    "parseJwt",
    "redirectToLogin",
    "redirectToLogout",
    "redirectToLogoutAsync",
    "redirectToSSO"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
